document.addEventListener("DOMContentLoaded", () => {
  $(document).on("click", "#idle-reports-export", function(){
    var url = `${window.location.href}/export.xlsx?`
    url += `begin_date=${$("#datatable-filter-begin-date").val()}&`
    url += `end_date=${$("#datatable-filter-end-date").val()}&`

    if ($('#datatable-filter-line').length && $('#datatable-filter-line').val()){
      url += `line_id=${$('#datatable-filter-line').val()}`
    }

    window.open(url)
  })
})